import { useEffect } from 'react';

/**
 * Carrega scripts de tracking quando os IDs estiverem definidos no .env do frontend.
 *
 * Variáveis suportadas (todas opcionais):
 *  - REACT_APP_GA4_ID         (ex: G-XXXXXXXXXX)         → Google Analytics 4
 *  - REACT_APP_META_PIXEL_ID  (ex: 1234567890123456)     → Meta (Facebook/Instagram) Pixel
 *  - REACT_APP_GTM_ID         (ex: GTM-XXXXXXX)          → Google Tag Manager
 *
 * Se nenhum estiver definido, o componente é um no-op (não injeta nada).
 * Quando o cliente fornecer os IDs, basta colar no .env e fazer build/deploy.
 */
const Analytics = () => {
  useEffect(() => {
    const ga4 = process.env.REACT_APP_GA4_ID;
    const pixel = process.env.REACT_APP_META_PIXEL_ID;
    const gtm = process.env.REACT_APP_GTM_ID;

    // ----- Google Analytics 4 -----
    if (ga4 && !document.getElementById('ga4-script')) {
      const script = document.createElement('script');
      script.id = 'ga4-script';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${ga4}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', ga4, { anonymize_ip: true });
    }

    // ----- Meta Pixel -----
    if (pixel && !window.fbq) {
      // eslint-disable-next-line
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
        document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', pixel);
      window.fbq('track', 'PageView');
    }

    // ----- Google Tag Manager -----
    if (gtm && !document.getElementById('gtm-script')) {
      // Sem innerHTML/string injection — montamos o GTM com APIs nativas seguras.
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const gtmScript = document.createElement('script');
      gtmScript.id = 'gtm-script';
      gtmScript.async = true;
      gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtm)}`;
      document.head.appendChild(gtmScript);
    }
    // eslint-disable-next-line
  }, []);

  return null;
};

export default Analytics;
